<template>
<!-- 部门人员选择 -->
  <div>
    <el-cascader v-model="orgId" class="arriveClass orgList" style="margin-right: 16px;" :placeholder="Language('部门')" :show-all-levels="false" clearable filterable ref="cascader"
     :options="orgList" :props="{ expandTrigger: 'hover', label:'orgName', value: 'orgId', checkStrictly: true }" @change="orgChange" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-cascader>
    <el-select class="arriveClass userList" v-model="userId" clearable filterable :placeholder="Language('人员')" :disabled="editType=='examine'||editType=='info'||editType=='return'">
      <!-- 数据类型为字符串 -->
      <el-option v-for="item in userList" :key="item.userId" :label="item.agentName" :value="item.userId+''"></el-option>
    </el-select>
  </div>
</template>

<script>
	import { getOrgList, getUserList } from '@/http/BranchManagement.js'
  import { covertTreeData, specialHandling } from '@/utils/auth'

export default {
  data(){
    return{
      orgList: [],
      userList: [],
      orgId: '',
      userId: '',
      vdnId: ''
    }
  },
  props:{
    editType: String, //修改类型 info：查看 add：新增 edit：编辑 examine：审批 return：回访
    default:{//回显信息
      type: Object,
      default: () => ({}) 
    }
  },
  watch:{
    default:{
      immediate: true,//先与created执行
      deep:true,
      handler: function (newV, oldV) {
        if(JSON.stringify(newV) ==JSON.stringify(oldV))return
        if(newV.orgId ==undefined || newV.orgId =='undefined' &&newV.orgId ==null || newV.orgId =='') return
        if(newV.userId ==undefined || newV.userId =='undefined' &&newV.userId ==null || newV.userId =='') return
        this.fetchOrgListFn(newV)
      },
    },
  },
  methods:{
    getuserList(data){
      if(data.length==0){
        this.userList =[];
        this.$refs.cascader.toggleDropDownVisible()//点击收起
        return
      } 
      let params = {
        orgId: data[data.length - 1],
        userKey: '',
        vdnId: this.vdnId
      }
      getUserList(params).then(res => {
        if(res && res.retCode == 1){
          this.userList = res.data.filter(item => { return item.flag == 1})
        }
      })
    },
    orgChange(data){
      this.userId = ''
      this.$refs.cascader.toggleDropDownVisible()//点击收起
      this.getuserList(data)
    },
    changeUserId(id){
      if(this.userId == id && this.userList.length>0) return
      if(this.orgId.length==0) return
      let params = {
        orgId: this.orgId[this.orgId.length - 1],
        userKey: '',
        vdnId: this.vdnId
      }
      getUserList(params).then(res => {
        if(res && res.retCode == 1){
          this.userList = res.data.filter(item => { return item.flag == 1})
        }
      })
    },
    fetchOrgListFn(data){
      getOrgList({
        isValid: '',
        orgName: '',
        vdnId: this.vdnId
      }).then(res => {
        if (res && res.retCode == 1) {
          this.orgList = covertTreeData(res.data,'0')
          if(data != undefined){
            if(this.orgList.length>0){
              if(data.orgId != undefined && data.orgId != 'undefined' && data.orgId != null){
                const resList = specialHandling(this.orgList, data.orgId)
                if(resList != undefined){
                  this.orgId = resList
                }
              }
              if(data.userId != undefined && data.userId != 'undefined' && data.userId != null){
                this.userId = data.userId
                this.changeUserId(this.userId)
              }
            }
          }
        }
      })
    }
  },
  created(){
    this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
    this.fetchOrgListFn()
  },
  mounted() {
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach((el) => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  }
}
</script>

<style scoped>
.arriveClass{
  width: calc(50% - 8px);
  display: inline-block;
}
.userList{
  margin-left: -5px;
}
</style>


// WEBPACK FOOTER //
// DepartPersonSelect.vue?51a7fd34